/**
 * Removes in-chat markdown proposal tables (Field | Proposed value) when
 * Review proposal + View Plan already show the same data.
 */
export function stripWriteApprovalProposalTable(text: string): string {
  const normalized = text.replace(/<br\s*\/?>/gi, "\n");
  const lines = normalized.split(/\n/);
  const out: string[] = [];
  let i = 0;
  let inProposalTable = false;

  while (i < lines.length) {
    const line = lines[i] ?? "";
    const trimmed = line.trim();

    if (isProposalTableHeader(trimmed)) {
      inProposalTable = true;
      i += 1;
      if (i < lines.length && isMarkdownSeparator(lines[i]?.trim() ?? "")) {
        i += 1;
      }
      continue;
    }

    if (inProposalTable) {
      if (!trimmed) {
        inProposalTable = false;
      }
      i += 1;
      continue;
    }

    out.push(line);
    i += 1;
  }

  return out
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

function isProposalTableHeader(line: string): boolean {
  if (!line.startsWith("|")) return false;
  const lower = line.toLowerCase();
  return lower.includes("field") && lower.includes("proposed");
}

function isMarkdownSeparator(line: string): boolean {
  return /^\|[\s\-:|]+\|$/.test(line);
}

export function assistantTextForChatDisplay(
  text: string,
  options: { hideProposalTable?: boolean }
): string {
  let result = text;
  if (options.hideProposalTable) {
    result = stripWriteApprovalProposalTable(result);
  }
  return result.trim();
}
